import {memo, ReactNode, useEffect, useState} from "react";
import MaterialStaticDatePicker, {MaterialStaticDatepickerProps} from "./MaterialStaticDatePicker";
import {Dialog, DialogContent, InputAdornment, InternalStandardProps, TextField, TextFieldProps} from "@mui/material";
import {CalendarMonthOutlined as CalendarIcon} from '@mui/icons-material';
import {formatLocaleDate, formatLocaleTime} from "@/utils/formatter";
import moment from "moment-timezone";
import MuiDateRangePicker from "@/components/common/MuiDatePicker/MuiDateRangePicker";
import usePrevious from "@/hooks/usePrevious";

// type ViewType<T> = T extends 'static' ?  MaterialStaticDatepickerProps : T extends 'dialog' ? {};

interface BasicProps {
    title?: string,
    view: 'static' | 'dialog',

    value?: string | undefined,

    onChange?: (date?:string) => void,
    fullWidth?: boolean,
}

type StaticProps = MaterialStaticDatepickerProps & BasicProps & {
    view?: 'static',
    variant?: undefined,
    DatepickerProps?: undefined,
    InputProps?: undefined,

    // onSelect: MaterialStaticDatepickerProps['onSelect'],
};

type DialogProps = TextFieldProps & BasicProps & {
    view?: 'dialog',
    // variant?: 'outlined' | 'standard' | 'filled',
    DatepickerProps?: MaterialStaticDatepickerProps,
    // onChange?: (date?:string) => void,
};

export type MuiDatePickerProps = DialogProps | StaticProps;

const MuiDatePicker = ({title, view='dialog', value, InputProps={}, DatepickerProps = {onChange: (date:Date | null) => {}}, onChange=()=>{}, onSelect=()=>{}, fullWidth,...props}:MuiDatePickerProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState<Date | null | undefined>();
    const [currentValue, setCurrentValue] = useState(value)

    function string2date (dateISOString?:string | undefined) {
        try {
            if (!dateISOString) return undefined;

            const t = moment(dateISOString).utc(true).format('YYYY-MM-DDTHH:mm:ss.000Z');
            return new Date(t);
        } catch (e) {
            return undefined;
        }
    }

    function date2localDate (date:Date | null | undefined) {
        try {
            const offset = moment().utcOffset();
            const changed = moment(date).subtract(offset, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000Z');

            // console.log('changed', changed);

            return new Date(changed).toISOString();
        } catch (e) {
            return '';
        }
    }

    function displayValue (date?:string) {
        try {
            if (!date) return;
            // return formatLocaleDate(date);
            return formatLocaleDate(date);
        } catch (e) {
            return ''
        }
    }

    useEffect(() => {
        setSelected(string2date(value));
        // setCurrentValue(value);
    }, [value])

    useEffect(() => {
        if (!currentValue) return;
        // console.log(currentValue);
        onChange(currentValue);
    }, [currentValue])

    useEffect(() => {
        if (!selected) return;
        setCurrentValue(date2localDate(selected));
    }, [selected])

    // function close

    return view === 'dialog' ? (
        <>
            <TextField {...props} InputProps={{
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <CalendarIcon />
                    </InputAdornment>
                ),
                ...InputProps,
            }} value={displayValue(currentValue)} onClick={ev => {
                setIsOpen(true);
            }} onFocus={ev => {
                setIsOpen(true);
                ev.target.blur();
            }} fullWidth={fullWidth} />

            <Dialog open={isOpen} onClose={event => {
                setIsOpen(false);
            }} PaperProps={{
                sx: {
                    maxWidth: 350,
                    minWidth: 300,
                }
            }} fullWidth>
                <MaterialStaticDatePicker {...DatepickerProps} title={title} selected={selected} onSelect={date => {
                    setSelected(date);
                    setIsOpen(false);
                }} onChange={date => {}}/>
            </Dialog>
        </>
    ) : (
        <MaterialStaticDatePicker fullWidth={fullWidth} {...props} title={title} selected={selected} onSelect={date => {
            setSelected(date);
        }}  onChange={date=>{
            console.log(date)
        }} />
        // <div>test</div>
    )
}

export {
    MuiDatePicker,
    MuiDateRangePicker,
    // MaterialStaticDatePicker,
}

export default memo(MuiDatePicker)